<template>
    <b-modal
        v-model="modal"
        :title="$t('group.internship.edit_message')"
        :ok-title="$t('common.edit')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk()"
        modal-class="apprentice-default-modal">
        <div>
            <b-form-group
                class="subject-group"
                :label="$t('group.internship.subject')"
                label-for="message-subject">
                <b-form-input
                    class="message-subject"
                    id="message-subject"
                    v-model="subject"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('group.internship.message')">
                <ckeditor
                    v-model="text"
                    :editor="editor"
                    :config="editorConfig"
                    :placeholder="$t('group.internship.edit_message')">
                </ckeditor>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-group-show-edit-message-modal-component',
    data() {
        return {
            modal: false,
            message: null,
            subject: '',
            text: '',
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
        };
    },
    methods: {
        show(message) {
            this.message = message;
            this.subject = message.subject;
            this.text = message.message;
            this.modal = true;
        },
        onOk() {
            this.$emit('update-message', { id: this.message.id, message: this.text, subject: this.subject });
        },
    },
};
</script>

<style scoped></style>
